(function () {
  /* IO Mobile Sticky ATC — Oct 2026 (duplicate theme only)
     - Mobile (<=767px): compact bar visible on load; hides while main buy controls are on screen
     - One IntersectionObserver, CSS transform transition, constant reserved body padding (no CLS)
     - Sticky never auto-picks a variant; Add to Cart clicks the existing #io-atc-btn (same form/handlers)
     - decoration_required: sticky routes to the existing #io-decorate-btn flow (no direct ATC while locked)
     - Lifts small fixed bottom widgets (chat etc.) above the bar; sits above full-width bottom bars
       (e.g. Shopify draft preview bar) instead of being covered by them */
  var MOBILE_MQ = '(max-width: 767px)';

  function formatMoney(cents, format) {
    cents = Number(cents);
    if (!isFinite(cents)) return '';
    var amount = (cents / 100).toFixed(2);
    var withComma = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var fmt = format || '${{amount}}';
    return fmt
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withComma)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, String(Math.round(cents / 100)))
      .replace(/\{\{\s*amount\s*\}\}/g, amount);
  }

  function findSizeSelect(form) {
    // Prefer the first required option the shopper still has to choose
    var candidates = [
      form.querySelector('[data-io-size-select]'),
      form.querySelector('[data-io-require-choice]'),
      form.querySelector('select[data-io-variant-select]:not([hidden])'),
      form.querySelector('[data-io-option-select][data-io-option-name="size"]')
    ];
    for (var i = 0; i < candidates.length; i++) {
      if (candidates[i] && !candidates[i].value) return candidates[i];
    }
    for (var j = 0; j < candidates.length; j++) if (candidates[j]) return candidates[j];
    return form.querySelector('[data-io-option-select]');
  }

  function getVariantSelect(form) {
    return form.querySelector('select[data-io-variant-select]');
  }

  function selectedVariantOption(form) {
    var sel = getVariantSelect(form);
    if (!sel || sel.tagName !== 'SELECT') return null;
    return sel.selectedOptions && sel.selectedOptions[0] ? sel.selectedOptions[0] : null;
  }

  function needsChoice(form) {
    if (form.querySelector('input[data-io-variant-select][type="hidden"]')) return false;
    var sizeSel = form.querySelector('[data-io-size-select]');
    if (sizeSel && !sizeSel.value) return true;
    var requireChoice = form.querySelector('[data-io-require-choice]');
    if (requireChoice && !requireChoice.value) return true;
    var visibleVariant = form.querySelector('select[data-io-variant-select]:not([hidden])');
    if (visibleVariant && !visibleVariant.value) return true;
    var opt = selectedVariantOption(form);
    if (!opt || !opt.value) return true;
    return false;
  }

  function variantReady(form) {
    if (form.querySelector('input[data-io-variant-select][type="hidden"]')) return true;
    if (needsChoice(form)) return false;
    var opt = selectedVariantOption(form);
    if (!opt || !opt.value) return false;
    if (opt.disabled || opt.getAttribute('data-available') === 'false') return false;
    return true;
  }

  /* 'needs_choice' | 'sold_out' | 'ready' */
  function variantState(form, bar) {
    if (bar && bar.getAttribute('data-io-product-available') === 'false') return 'sold_out';
    if (form.querySelector('input[data-io-variant-select][type="hidden"]')) {
      if (bar && bar.getAttribute('data-io-current-available') === 'false') return 'sold_out';
      return 'ready';
    }
    if (needsChoice(form)) return 'needs_choice';
    return variantReady(form) ? 'ready' : 'sold_out';
  }

  function syncPrice(form) {
    var opt = selectedVariantOption(form);
    if (!opt || !opt.getAttribute('data-price')) return;
    var cents = opt.getAttribute('data-price');
    var priceEl = document.querySelector('[data-io-price]');
    var format = priceEl ? priceEl.getAttribute('data-io-money-format') : null;
    var formatted = formatMoney(cents, format);
    if (!formatted) return;
    if (priceEl) priceEl.textContent = formatted;
    document.querySelectorAll('[data-io-sticky-price]').forEach(function (el) {
      el.textContent = formatted;
    });
  }

  function showToast(msg) {
    var existing = document.getElementById('io-variant-toast');
    if (existing) existing.remove();
    var t = document.createElement('div');
    t.id = 'io-variant-toast';
    t.setAttribute('role', 'status');
    t.className = 'io-variant-toast';
    t.textContent = msg;
    document.body.appendChild(t);
    setTimeout(function () {
      if (t.parentNode) t.parentNode.removeChild(t);
    }, 3200);
  }

  function promptVariant(form, msg) {
    var target = findSizeSelect(form);
    if (!target) {
      showToast(msg || 'Select a size to continue.');
      return;
    }
    var wrap = target.closest('.io-product-option') || target;
    wrap.classList.add('is-prompt');
    target.classList.add('io-needs-choice');
    // Scroll first, then focus without a second jump. Never changes the selected value.
    var label = wrap.querySelector ? wrap.querySelector('.io-field-label') : null;
    (label || wrap).scrollIntoView({ behavior: 'smooth', block: 'center' });
    try { target.focus({ preventScroll: true }); } catch (e) { try { target.focus(); } catch (e2) {} }
    showToast(msg || 'Select a size to continue.');
    setTimeout(function () {
      wrap.classList.remove('is-prompt');
      target.classList.remove('io-needs-choice');
    }, 2200);
  }

  function openDecoratorSafe() {
    if (typeof window.openDecorator === 'function') {
      try { window.openDecorator(); return true; }
      catch (err) { console.error('openDecorator failed', err); }
    }
    var modal = document.getElementById('deco-modal');
    if (modal) {
      modal.classList.add('open');
      document.body.style.overflow = 'hidden';
      return true;
    }
    return false;
  }

  function getPrimaryCta(form) {
    var decorate = document.getElementById('io-decorate-btn');
    if (decorate) {
      var style = window.getComputedStyle(decorate);
      if (style.display !== 'none' && style.visibility !== 'hidden') return decorate;
    }
    var atc = document.getElementById('io-atc-btn');
    if (atc && atc.getAttribute('data-io-deco-locked') === '1') {
      if (decorate) return decorate;
    }
    return atc || decorate;
  }

  function decoLocked() {
    var atc = document.getElementById('io-atc-btn');
    return !!(atc && atc.getAttribute('data-io-deco-locked') === '1');
  }

  function syncAtcEnabled(form) {
    var atc = form.querySelector('#io-atc-btn');
    if (!atc || atc.getAttribute('data-io-deco-locked') === '1') return;
    if (atc.getAttribute('data-io-awaiting-variant') !== '1' && !form.querySelector('[data-io-size-select], [data-io-require-choice]')) return;
    var ready = variantReady(form);
    atc.disabled = !ready;
    if (ready) {
      atc.removeAttribute('disabled');
      atc.removeAttribute('aria-disabled');
    } else {
      atc.setAttribute('aria-disabled', 'true');
    }
  }

  function expPublish(name, extra, opts) {
    if (window.IOExp && typeof window.IOExp.publish === 'function') {
      return window.IOExp.publish(name, extra, opts);
    }
    return false;
  }

  function bindDecorateClicks(form) {
    function handleDecorateClick(e) {
      e.preventDefault();
      e.stopPropagation();
      if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
      if (!variantReady(form)) {
        expPublish('io_sticky_tap_pre_variant', { cta: 'customize' }, {});
        promptVariant(form, 'Select a size, then customize with your logo.');
        return;
      }
      if (!openDecoratorSafe()) {
        showToast('Customization tool could not open. Please refresh and try again.');
      }
    }

    var decoBtn = document.getElementById('io-decorate-btn');
    if (decoBtn) {
      decoBtn.removeAttribute('onclick');
      decoBtn.addEventListener('click', handleDecorateClick, true);
    }
    // Sticky customize button is routed through #io-decorate-btn in initSticky (same handler)
    document.querySelectorAll('[data-io-sticky-customize]').forEach(function (btn) {
      btn.removeAttribute('onclick');
    });
  }

  /* ---------- fixed bottom obstacle handling ---------- */
  var OWN_SELECTOR = '[data-io-sticky-atc], #io-variant-toast, .io-ef, #deco-modal, .io-media-lightbox';
  function isOwn(el) {
    try { return !!(el.matches && (el.matches(OWN_SELECTOR) || el.closest(OWN_SELECTOR))); } catch (e) { return false; }
  }

  function collectFixedBottom() {
    var vw = window.innerWidth, vh = window.innerHeight;
    var out = { bars: [], widgets: [] };
    var seen = [];
    function consider(el) {
      if (!el || el.nodeType !== 1 || seen.indexOf(el) !== -1 || isOwn(el)) return;
      seen.push(el);
      var cs;
      try { cs = window.getComputedStyle(el); } catch (e) { return; }
      if (cs.position !== 'fixed' || cs.display === 'none' || cs.visibility === 'hidden') return;
      var r = el.getBoundingClientRect();
      if (r.width < 4 || r.height < 4) return;
      if (r.height > vh * 0.45) return;          // full-screen overlays / drawers: ignore
      var orig = el.getAttribute('data-io-sticky-orig-bottom');
      var lifted = orig !== null;
      var liftPx = lifted ? parseFloat(el.getAttribute('data-io-sticky-lift') || '0') : 0;
      var bottomGap = vh - (r.bottom + liftPx);
      if (bottomGap > 40 || r.top >= vh) return;  // not anchored at bottom
      var isPreviewBar = /^PBar/i.test(el.id || '') || /preview-bar/i.test(el.id || '');
      if (!isPreviewBar && (r.width >= vw * 0.6)) out.bars.push({ el: el, h: Math.max(0, vh - r.top - liftPx) });
      else if (isPreviewBar) out.bars.push({ el: el, h: Math.max(0, vh - r.top) });
      else out.widgets.push(el);
    }
    var body = document.body;
    if (!body) return out;
    var kids = body.children;
    for (var i = 0; i < kids.length; i++) {
      consider(kids[i]);
      var g = kids[i].children;
      if (g && g.length < 40) for (var j = 0; j < g.length; j++) consider(g[j]);
      if (kids[i].shadowRoot) {
        var sk = kids[i].shadowRoot.children;
        for (var k = 0; k < sk.length && k < 40; k++) consider(sk[k]);
      }
    }
    ['#PBarNextFrameWrapper', '#preview-bar-iframe', '#ShopifyChat', 'inbox-online-store-chat', '#shopify-chat'].forEach(function (s) {
      var el = document.querySelector(s);
      if (el) consider(el);
    });
    return out;
  }

  function initSticky() {
    var bar = document.querySelector('[data-io-sticky-atc]');
    var form = document.querySelector('form.io-product-form');
    if (!form) return;

    var stickyImpressed = false;
    var variantReadyFired = false;
    var stickyEnabledFired = false;

    form.querySelectorAll('[data-io-option-select], [data-io-variant-select]').forEach(function (el) {
      el.addEventListener('change', function () {
        form.setAttribute('data-io-variant-touched', '1');
        syncAtcEnabled(form);
        syncPrice(form);
        updateStickyLabel();
        maybeVariantReady();
      });
    });
    syncAtcEnabled(form);
    syncPrice(form);
    bindDecorateClicks(form);

    if (!bar) return;

    var mq = window.matchMedia ? window.matchMedia(MOBILE_MQ) : { matches: window.innerWidth <= 767 };
    var btn = bar.querySelector('[data-io-sticky-btn]') || bar.querySelector('[data-io-sticky-submit], [data-io-sticky-customize]');
    var isDecoProduct = bar.getAttribute('data-io-deco-required') === 'true' || !!bar.querySelector('[data-io-sticky-customize]');
    var hasSizeOption = !!form.querySelector('[data-io-size-select]') || bar.getAttribute('data-io-has-size') === 'true';
    var enabled = false;
    var shown = false;
    var controlsInView = false;
    var pendingTimer = null;
    var liftedWidgets = [];

    function mode() {
      // 'customize' while decoration lock is active, otherwise 'atc'
      return isDecoProduct && decoLocked() ? 'customize' : 'atc';
    }

    function maybeVariantReady() {
      if (!variantReady(form)) return;
      if (!variantReadyFired) {
        variantReadyFired = true;
        var opt = selectedVariantOption(form);
        expPublish('io_variant_ready', {
          variant_id: opt && opt.value ? opt.value : null
        }, { once: true });
      }
      maybeStickyEnabled();
    }

    function maybeStickyEnabled() {
      if (stickyEnabledFired) return;
      if (!variantReady(form)) return;
      if (!shown) return;
      stickyEnabledFired = true;
      expPublish('io_sticky_atc_enabled', {
        cta: mode() === 'customize' ? 'customize' : 'add_to_cart'
      }, { once: true });
    }

    function updateStickyLabel() {
      if (!btn) return;
      var state = variantState(form, bar);
      var m = mode();
      var label, disabled = false;
      if (state === 'sold_out') {
        label = 'Sold Out'; disabled = true;
      } else if (m === 'customize') {
        label = 'Customize / Add Logo';
      } else if (state === 'needs_choice') {
        label = hasSizeOption ? 'Select Size' : 'Select Options';
      } else {
        label = 'Add to Cart';
      }
      if (btn.textContent !== label) btn.textContent = label;
      btn.disabled = disabled;
      if (disabled) btn.setAttribute('aria-disabled', 'true'); else btn.removeAttribute('aria-disabled');
      btn.setAttribute('data-io-sticky-state', state);
      btn.setAttribute('data-io-sticky-mode', m);
      bar.setAttribute('data-io-sticky-state', state);
    }

    /* --- layout vars: bar height, obstacle offset --- */
    function applyLayout() {
      if (!enabled) return;
      var obs = collectFixedBottom();
      var offset = 0;
      obs.bars.forEach(function (b) { if (b.h > offset) offset = b.h; });
      offset = Math.min(Math.round(offset), Math.round(window.innerHeight * 0.3));
      var root = document.documentElement;
      root.style.setProperty('--io-sticky-offset', offset + 'px');
      root.style.setProperty('--io-sticky-safe', offset > 0 ? '0px' : 'env(safe-area-inset-bottom, 0px)');
      var h = Math.round(bar.getBoundingClientRect().height) || 64;
      root.style.setProperty('--io-sticky-h', h + 'px');
      root.style.setProperty('--io-sticky-reserve', (h + offset) + 'px');
      // Lift small floating widgets (chat bubbles etc.) above the bar
      var lift = h + offset;
      obs.widgets.forEach(function (el) {
        if (liftedWidgets.indexOf(el) === -1) {
          var cs = window.getComputedStyle(el);
          el.setAttribute('data-io-sticky-orig-bottom', el.style.bottom || '');
          el.setAttribute('data-io-sticky-orig-bottom-computed', cs.bottom);
          liftedWidgets.push(el);
        }
      });
      syncWidgetLift(lift);
    }

    function syncWidgetLift(lift) {
      liftedWidgets.forEach(function (el) {
        if (!el.isConnected) return;
        var base = parseFloat(el.getAttribute('data-io-sticky-orig-bottom-computed')) || 0;
        if (shown && enabled) {
          el.style.setProperty('bottom', (base + lift) + 'px', 'important');
          el.style.setProperty('transition', 'bottom .22s ease');
          el.setAttribute('data-io-sticky-lift', String(lift));
        } else {
          var orig = el.getAttribute('data-io-sticky-orig-bottom') || '';
          if (orig) el.style.setProperty('bottom', orig); else el.style.removeProperty('bottom');
          el.setAttribute('data-io-sticky-lift', '0');
        }
      });
    }

    function setShown(next, instant) {
      if (next === shown) return;
      shown = next;
      if (instant) {
        bar.classList.add('no-anim');
        requestAnimationFrame(function () { requestAnimationFrame(function () { bar.classList.remove('no-anim'); }); });
      }
      bar.classList.toggle('is-shown', shown);
      bar.setAttribute('aria-hidden', shown ? 'false' : 'true');
      document.body.classList.toggle('io-sticky-atc-shown', shown);
      var lift = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--io-sticky-reserve')) || 0;
      syncWidgetLift(lift);
      if (shown) {
        updateStickyLabel();
        if (!stickyImpressed) {
          stickyImpressed = true;
          expPublish('io_sticky_impression', {
            cta: mode() === 'customize' ? 'customize' : 'add_to_cart'
          }, { once: true });
        }
        maybeStickyEnabled();
      }
    }

    function scheduleVisibility() {
      if (!enabled) return;
      var want = !controlsInView;
      if (pendingTimer) clearTimeout(pendingTimer);
      // Small debounce = hysteresis against fling-boundary flicker
      pendingTimer = setTimeout(function () { pendingTimer = null; setShown(want); }, 90);
    }

    /* Legacy body class: "scrolled past primary CTA" (used by io-exit-feedback eligibility). Unchanged semantics. */
    function syncLegacyPastClass() {
      var primary = getPrimaryCta(form);
      var past = !!(primary && primary.getBoundingClientRect().top < 0);
      if (document.body.classList.contains('io-sticky-atc-visible') !== past) {
        document.body.classList.toggle('io-sticky-atc-visible', past);
      }
    }

    /* --- single IntersectionObserver over the main buy controls --- */
    var io = null;
    var inView = typeof Map === 'function' ? new Map() : null;
    function controlTargets() {
      var t = [];
      form.querySelectorAll('.io-product-option').forEach(function (el) { t.push(el); });
      var vis = form.querySelector('select[data-io-variant-select]:not([hidden])');
      if (vis && t.indexOf(vis) === -1) t.push(vis);
      var qty = form.querySelector('input[name="quantity"]');
      if (qty) t.push(qty);
      var atc = document.getElementById('io-atc-btn');
      var deco = document.getElementById('io-decorate-btn');
      if (atc) t.push(atc);
      if (deco) t.push(deco);
      return t;
    }
    function startObserver() {
      if (io || !('IntersectionObserver' in window) || !inView) return false;
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { inView.set(en.target, en.isIntersecting); });
        var any = false;
        inView.forEach(function (v) { if (v) any = true; });
        controlsInView = any;
        scheduleVisibility();
      }, { root: null, rootMargin: '0px 0px -72px 0px', threshold: 0 });
      controlTargets().forEach(function (el) { io.observe(el); });
      return true;
    }
    function stopObserver() {
      if (io) { io.disconnect(); io = null; }
      if (inView) inView.clear();
    }
    function fallbackScrollCheck() {
      if (io || !enabled) return;
      var vh = window.innerHeight, any = false;
      controlTargets().forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.height > 0 && r.bottom > 0 && r.top < vh - 72) any = true;
      });
      controlsInView = any;
      scheduleVisibility();
    }

    function enable() {
      if (enabled) return;
      enabled = true;
      bar.removeAttribute('hidden');
      document.body.classList.add('io-sticky-atc-enabled');
      applyLayout();
      updateStickyLabel();
      // Decide initial state synchronously so the bar is visible immediately on load (no slide-in)
      var vh = window.innerHeight, any = false;
      controlTargets().forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.height > 0 && r.bottom > 0 && r.top < vh - 72) any = true;
      });
      controlsInView = any;
      setShown(!any, true);
      if (!startObserver()) window.addEventListener('scroll', fallbackScrollCheck, { passive: true });
    }

    function disable() {
      if (!enabled) return;
      setShown(false, true);
      enabled = false;
      stopObserver();
      window.removeEventListener('scroll', fallbackScrollCheck);
      bar.setAttribute('hidden', '');
      document.body.classList.remove('io-sticky-atc-enabled', 'io-sticky-atc-shown');
      syncWidgetLift(0);
    }

    function syncMode() {
      if (mq.matches) enable(); else disable();
    }

    if (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var state = variantState(form, bar);
        if (state === 'sold_out') return;
        if (mode() === 'customize') {
          // Exactly the existing "Customize" button flow (size gate -> openDecorator). No cart add.
          var deco = document.getElementById('io-decorate-btn');
          if (deco) deco.click();
          else if (!openDecoratorSafe()) showToast('Customization tool could not open. Please refresh and try again.');
          return;
        }
        if (state === 'needs_choice') {
          expPublish('io_sticky_tap_pre_variant', { cta: 'add_to_cart' }, {});
          promptVariant(form, hasSizeOption ? 'Select a size to continue.' : 'Select an option to continue.');
          return;
        }
        var opt = selectedVariantOption(form);
        if (window.IOExp && typeof window.IOExp.markPendingAddToCart === 'function') {
          window.IOExp.markPendingAddToCart({
            variant_id: opt && opt.value ? opt.value : null,
            source: 'sticky_submit',
            cta_source: 'sticky'
          });
        }
        var atc = document.getElementById('io-atc-btn');
        // Same form, same submit button, same handlers as the main Add to cart
        if (atc && !atc.disabled) atc.click();
        else if (atc && typeof form.requestSubmit === 'function') form.requestSubmit(atc);
        else form.submit();
      });
    }

    // Decoration unlock flips sticky from Customize -> Add to Cart
    var atcEl = document.getElementById('io-atc-btn');
    if (atcEl && 'MutationObserver' in window) {
      new MutationObserver(function () { updateStickyLabel(); }).observe(atcEl, { attributes: true, attributeFilter: ['data-io-deco-locked', 'disabled', 'style'] });
    }

    var layoutTimer = null;
    function scheduleLayout() {
      if (layoutTimer) return;
      layoutTimer = setTimeout(function () { layoutTimer = null; applyLayout(); }, 250);
    }
    if ('MutationObserver' in window) {
      new MutationObserver(scheduleLayout).observe(document.body, { childList: true });
    }
    window.addEventListener('resize', function () { scheduleLayout(); });
    if (window.visualViewport) window.visualViewport.addEventListener('resize', scheduleLayout);
    window.addEventListener('load', scheduleLayout);
    setTimeout(applyLayout, 1200);
    setTimeout(applyLayout, 3500);
    if ('ResizeObserver' in window) new ResizeObserver(scheduleLayout).observe(bar);

    window.addEventListener('scroll', syncLegacyPastClass, { passive: true });
    if (mq.addEventListener) mq.addEventListener('change', syncMode);
    else if (mq.addListener) mq.addListener(syncMode);

    syncMode();
    syncLegacyPastClass();
    updateStickyLabel();
    maybeVariantReady();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initSticky);
  else initSticky();
})();
